import { render, staticRenderFns } from "./MpuertolocalForm.vue?vue&type=template&id=0f6b928c"
import script from "./MpuertolocalForm.vue?vue&type=script&lang=js"
export * from "./MpuertolocalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports